export default function Marquee({ items }) {
  const list = items && items.length ? items : [];
  const row = [...list, ...list];
  return (
    <div className="relative border-y border-gold/15 bg-storm-800/40 py-4 overflow-hidden" data-testid="marquee-ribbon">
      <div className="flex w-max animate-marquee whitespace-nowrap">
        {[0, 1].map((half) => (
          <div key={half} className="flex shrink-0">
            {row.map((item, i) => (
              <span key={`${half}-${i}`} className="flex items-center font-display font-semibold uppercase italic tracking-wider text-lg text-slate-400">
                <span className="px-6">{item}</span>
                <span className="text-gold">✦</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
